import { fontFaces as plexFontFaces, fontName as plexFontName } from './plex';

export const fontNames = [plexFontName];

export const fontFaces = [plexFontFaces];
